import { goToDashboard, redirectAvailabilityErrorOr404, redirectRootVisit, goToFAQPage } from '@/helpers/redirects';

export default [
  {
    path: '/conteudo',
    name: 'content',
    beforeEnter: () => goToDashboard(),
  },
  {
    path: '/minhas-assinaturas',
    name: 'subscriptions',
    beforeEnter: () => goToDashboard(),
  },
  {
    path: '/meus-conteudos',
    name: 'myContents',
    beforeEnter: () => goToDashboard(),
  },
  {
    path: '/meus-videos',
    name: 'myVideos',
    beforeEnter: () => goToDashboard(),
  },
  {
    path: '/pwa',
    name: 'pwa',
    beforeEnter: () => redirectAvailabilityErrorOr404(),
  },
  {
    path: '/contato',
    name: 'contact',
    beforeEnter: () => goToFAQPage(),
  },
  {
    path: '/faq',
    name: 'faq',
    beforeEnter: () => goToFAQPage(),
  },
  {
    path: '*',
    name: 'notFound',
    beforeEnter: () => redirectRootVisit(),
  },
  {
    path: '/404',
    name: 'errorPage',
    beforeEnter: () => redirectAvailabilityErrorOr404(),
  },
];